/** Spacing, radius, layout, motion — docs/04-design-system.md §2.4–§2.6. */

/** 4 pt base scale. Layout uses only these values. */
export const space = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
} as const

export type SpaceToken = keyof typeof space

export const radius = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  full: 999,
} as const

export type RadiusToken = keyof typeof radius

/** Layout constants — docs/04 §2.4. Tab/app bar heights exclude safe areas. */
export const layout = {
  screenPaddingX: 16,
  sectionGap: 24,
  cardPadding: 16,
  listRowPaddingY: 12,
  minTouchTarget: 44,
  tabBarHeight: 56,
  appBarHeight: 56,
  maxContentWidth: 560,
} as const

export type LayoutToken = keyof typeof layout

/** Hairline border, and the 2 pt focus ring — docs/04 §2.5. */
export const borderWidth = {
  hairline: 1,
  focus: 2,
} as const

/** Motion durations in milliseconds — docs/04 §2.6. */
export const motion = {
  instant: 0,
  fast: 150,
  base: 250,
  slow: 400,
} as const

export type MotionToken = keyof typeof motion

export const easing = {
  fast: 'ease-out',
  base: 'ease-in-out',
  slow: 'ease-in-out',
} as const

/** Icon sizes — docs/04 §2.7. */
export const iconSize = {
  inline: 16,
  listRow: 20,
  default: 24,
  emptyState: 32,
} as const
